import { h, defineComponent, onMounted, ref } from 'vue';
import { t } from '@/ui/i18n/i18n';

export interface PhoneNumberInputProps {
  value: string;
  size: 'sm' | 'md' | 'lg';
  noValidation?: boolean;
  placeholder?: string;
  showCodeOnList?: boolean;
  noExample?: boolean;
  disabled?: boolean;
  translations?: Record<string, string>;
}

export interface PhoneNumberUpdateData {
  countryCallingCode: string;
  countryCode: string;
  e164: string;
  formatInternational: string;
  formatNational: string;
  isValid: boolean;
  nationalNumber: string;
  type?: string;
  uri: string;
}

/**
 * @see https://louismazel.github.io/maz-ui/documentation/maz-phone-number-input
 */
export const PhoneNumberInput = defineComponent<PhoneNumberInputProps>({
  name: 'PhoneNumberInput',
  props: ['value', 'size', 'noValidation', 'placeholder', 'showCodeOnList', 'noExample', 'disabled', 'translations'],
  setup(props, ctx) {
    onMounted(() => {
      const container = document.querySelector<HTMLElement>('.phone-number-input')!;
      const optionsContainer = document.querySelector<HTMLElement>('.maz-select__options-list')!;

      optionsContainer.style.width = `${container.offsetWidth}px`;
      optionsContainer.style.maxWidth = `${container.offsetWidth}px`;
    });
    const isFocused = ref(false);

    return function render() {
      return h('MazPhoneNumberInput', {
        class: `phone-number-input ${isFocused.value ? 'phone-number-input--focused' : ''}`,
        props: {
          value: props.value,
          size: props.size,
          noValidation: !!props.noValidation,
          noExample: !!props.noExample,
          placeholder: props.placeholder || '',
          showCodeOnList: !!props.showCodeOnList,
          disabled: !!props.disabled,
          defaultCountryCode: 'DE',
          translations: props.translations ?? {
            countrySelectorLabel: t('common.country'),
            countrySelectorError: t('common.error'),
            countrySelectorSearchPlaceholder: t('form.search-country'),
            phoneNumberLabel: t('form.enter-phone'),
            example: '',
          },
        },
        on: {
          input: (v: string) => ctx.emit('input', v),
          update: (v: PhoneNumberUpdateData) => ctx.emit('update', v),
          focus: () => { isFocused.value = true; },
          blur: () => { isFocused.value = false; },
        },
      });
    };
  },
});
